import { Injectable } from '@angular/core';
import { AppAccessToken } from '../models/app-access-token';
import { Constants } from '../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  public setItem<T>(key: string, obj: T) {
    const value = JSON.stringify(obj);
    localStorage.setItem(key, value);
  }

  public getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);

    if (!item) {
      return null;
    }

    const obj: T = JSON.parse(item);
    return obj;
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  setToken(token: AppAccessToken) {
    this.setItem(Constants.AuthData, token);
  }

  getToken(): AppAccessToken | null {
    return this.getItem(Constants.AuthData);
  }

  removeToken() {
    this.removeItem(Constants.AuthData);
  }

  clear() {
    localStorage.clear();
  }
}
